module.exports = __webpack_public_path__ + "img/ic-info.6f5519b7.svg";